export const CustomStateCell = (rowProps) => {
    const { value } = rowProps;
    if(!value){
        return <div></div>;
    }
    else
    {
        const splitValue = value.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g).join(' ');
        return (
            rowProps.data === undefined? <div></div>  : 
            <>
                {splitValue}
            </>   
        )
    }
    
};